import * as Sentry from '@sentry/react'

// The runtime executes inside the preview iframe, so its unhandled errors fire on the iframe's window —
// which the app-level Sentry global handlers (index.tsx) never see. Mirroring the Field App host, we catch
// them at the host boundary and report via the host's Sentry; the runtime itself stays Sentry-free. The
// iframe is same-origin (allow-same-origin), so the host can listen on its window directly.

export type RuntimeErrorContext = {
  entryEntityId: string
  configVersion: string
  // Trace id of the runtime session span, so a Sentry event ties back to the Grafana trace. Null when tracing is off.
  traceId: string | null
}

export const captureRuntimeError = (error: unknown, context: RuntimeErrorContext): void => {
  Sentry.captureException(error, {
    tags: { source: 'runtime-preview' },
    contexts: { runtime: { ...context } },
  })
}

export const attachRuntimeErrorReporting = (
  win: Pick<Window, 'addEventListener'>,
  report: (error: unknown) => void
): void => {
  win.addEventListener('error', (event) => report(event.error ?? new Error(event.message)))
  win.addEventListener('unhandledrejection', (event) =>
    report(event.reason ?? new Error('Unhandled promise rejection in runtime'))
  )
}
